import { useContext, useEffect, useState, useRef } from "react";
import { Column, DateTimePicker, Icon, Label, Panel, Row, Select, TextField } from "../../components";
import * as label from '../../shared/util/label';
import Grid from "../../components/components/Grid/Grid";
import { Link } from "react-router-dom";
import { Collapse, Container, FloatingLabel, Form, Table } from "react-bootstrap";
import React from "react";
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import './CustomerActivity.scss';
import CustomerActivityService from "./CustomerActivityService";
import DropDownWithLabelInline from "../../shared/components/input/DropDownWithLabelInline";
import DatePicker from "react-datepicker";
import moment from "moment";
import DateTimePickerWithLabelFormGroup from "../../shared/components/input/DateTimePickerWithLabelFormGroup";
import { SelectOption } from "../../shared/components/input";
import { CustomerActivityAddRequest } from "../model/CustomerActivityAddRequest";
import * as constant from '../../shared/util/constant';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../shared/store";
import { AppEvenType, clearAppEvent } from "../../shared/store/component-notification/ComponentNotification";
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import TextInputWithLabelInline from "../../shared/components/input/TextInputWithLabelInline";
import CustomerDetailService from "../customer-details/CustomerDetailService";
import { updateCustomers } from "../customer-slice/Customer-slice";
import { AbilityContext } from "../../shared/abilities/AbilityContext";
import { Button } from "primereact/button";
import ExportToCsv from '../../shared/components/ExportToCSV/ExportToCsv';
import { CUSTOMER_ACTIVITY_EXPORT_COLUMNS, CUSTOMER_ACTIVITY_CUSTOM_HEADER_ROWS } from '../../shared/util/constant';
import AppContext from "../../shared/components/AppContext";
import { CommonUtility } from "../../Services/CommonUtility";
import { CustomerActivityFilterRequest } from "../model/CustomerActivityFilterRequest";

const CustomerActivity = (props) => {

    const defaultAddActivityRequest: CustomerActivityAddRequest = {
        custId: '',
        activityTypeId: '',
        tranTypeId: '',
        policyId: '',
        activityEffDate: new Date(),
        description: '',
        claimId: null
    }

    const defaultActivityFilterRequest: CustomerActivityFilterRequest = {
        custId:'',
        activityTypeId:'',
        activityType:'',
        tranTypeId:'',
        transType:'',
        policyId:'',
        policyNumber:'',
        activityEffDate:null,
        activityDate:null,
        activityTime:null,
        department:'',
        description:'',
        claimId:'',
        UserName:'',
        policyEffectiveDate:null
    }

    const modalContext = useConfirmationModalContext();
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    const customerDetailService = new CustomerDetailService();
    const [isEffectiveDateInvalid, setIsEffectiveDateInvalid] = useState(false);
    const [effectiveDateValidError, setEffectiveDateValidError] = useState(null);
    const eventState = useSelector((state: RootState) => state?.eventState);
    const dispatch = useDispatch();
    const [isFormSaved, setIsFormSaved] = useState(true);
    const [isActivityDescriptionEmpty, setIsActivityDescriptionEmpty] = useState(false);
    const [isActivityTypeEmpty, setIsActivityTypeEmpty] = useState(false);
    const [isPolicyIdEmpty, setIsPolicyIdEmpty] = useState(false);
    const [isAddActivityPanelVisible, setIsAddActivityPanelVisible] = useState(false);
    const [customerActivities, setCustomerActivities] = useState([]);
    const [customerId, setCustomerId] = useState(props.customerId);
    const [pageNumber, setPagenumber] = useState(1);
    const [activityTypes, setActivityTypes] = useState<SelectOption[]>([]);
    const [transactionTypes, setTransactionTypes] = useState<SelectOption[]>([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedTime, setSelectedTime] = useState(new Date());
    const [customerDependentsForSelect, setCustomerDependentsForSelect] = useState<SelectOption[]>([]);
    const [claimsForSelect, setClaimsForSelect] = useState<SelectOption[]>([]);
    const [policiesForSelect, setPoliciesForSelect] = useState<SelectOption[]>([]);
    const customerActivityService = new CustomerActivityService();
    const [addActivityRequest, setAddActivityRequest] = useState<CustomerActivityAddRequest>(defaultAddActivityRequest);
    const ab_subject = "Customer Activity";
    const ability = useContext(AbilityContext);
    const canUserCreateCustomerActivity = ability.can('create', ab_subject, constant.ScreenName.CUSTOMER_ACTIVITY);
    const isUserPermitToViewExportButton = ability.can('view', ab_subject, constant.CustomerActivityPrivileges.EXPORT);
    const isExportDisabledForUser = !ability.can('read', ab_subject, constant.CustomerActivityPrivileges.EXPORT);
    const [loadMoreButton, setLoadMoreButton] = useState(false);
    // const [isPolicyOptional, setIsPolicyOptional] = useState(true);
    const MAX_DESCRIPTION_LENGTH = 8000;
    const [isDescriptionTooLong, setIsDescriptionTooLong] = useState(false);
    const hasPolicyOptions = (policiesForSelect?.length ?? 0) > 0;

    const getDefaultPolicyId = () => {
        return policiesForSelect.length === 1 ? String(policiesForSelect[0].value) : '';
    }


    const handleDescriptionChange = (event) => {
        const value = event.currentTarget.value;
        onFieldChange('description', value);
        setTimeout(() => {
            const textarea = event.target;
            textarea.scrollTop = textarea.scrollHeight;
        }, 0);
    };

    // Only normalize on paste
    const handleDescriptionPaste = (event) => {
        event.preventDefault();
        let paste = (event.clipboardData || window.Clipboard).getData('text');
        paste = CommonUtility.normalizeEmailText(paste);
        // Insert at cursor position
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const currentValue = textarea.value;
        const newValue = currentValue.slice(0, start) + paste + currentValue.slice(end);
        onFieldChange('description', newValue);
        setTimeout(() => {
            textarea.selectionStart = textarea.selectionEnd = start + paste.length;
        }, 0);
    };

    const [addActivityRequestFilter, setAddActivityRequestFilter] = useState<CustomerActivityFilterRequest>(defaultActivityFilterRequest);
    const [selectedDateFilter, setSelectedDateFilter] = useState(null);
    const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);
    const [customerActivitiesNoFilter, setCustomerActivitiesNoFilter] = useState([]);
    const [selectedEffectiveDateFilter, setSelectedEffectiveDateFilter] = useState(null);
    const [selectedAction, setSelectedAction] = useState(null);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [selectedDesc, setSelectedDesc] = useState(null);
    const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
    const [selectedCSR, setSelectedCSR] = useState(null);
    const addActivityControlRef = useRef(null);
    const saveControlRef = useRef(null);
    const tableWrapperRef = useRef<HTMLDivElement>(null);
    const myContext = useContext(AppContext);

    // Get customer name and mailing address
    const customerName = customerInfo?.customer?.firstName && customerInfo?.customer?.lastName
        ? `${customerInfo.customer.firstName} ${customerInfo.customer.lastName}`
        : customerInfo?.customer?.firstName || "";

    // Build mailing address by skipping null/undefined/empty fields and joining with comma
    const mailingAddress = [
        customerInfo?.customer?.address1,
        customerInfo?.customer?.address2,
        customerInfo?.customer?.city,
        customerInfo?.customer?.state,
        customerInfo?.customer?.zipCode
    ].filter(part => part && String(part).trim() !== "").join(", ");

    // Prepare data and headers for Export
    const today = new Date();
    const fileName = `${customerName}_Activity_${CommonUtility.formateDate(today, "MMDDYYYY")}.csv`;
    const exportHeaderKeys = Object.keys(CUSTOMER_ACTIVITY_EXPORT_COLUMNS);
    const exportHeaders = exportHeaderKeys.map(key => CUSTOMER_ACTIVITY_EXPORT_COLUMNS[key]);
    const exportData = customerActivities.map(activity => {

        // Normalize description for export: remove all blank lines and join with a space
        let description = activity.description || "";
        description = description
            .split(/\r?\n/)
            .map(line => line.trim())
            .filter(line => line.length > 0)
            .join(' ');
        return {
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.POLICY_NUMBER]: activity.policyNumber || "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.ACTION_TYPE]: activity.activityType || "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.DATE]: activity.activityEffDate ? new Date(activity.activityEffDate).toLocaleDateString("en-US") : "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.TIME]: activity.activityEffDate ? new Date(activity.activityEffDate).toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric", hour12: true }) : "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.TRANSACTION]: activity.transactionType || "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.DESCRIPTION]: description,
           
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.EFFECTIVE_DATE]: activity.polEffDate || "",
            [CUSTOMER_ACTIVITY_EXPORT_COLUMNS.CSR]: activity.csr || ""
        };
    });
    const customHeaderRows = [
        `"${CUSTOMER_ACTIVITY_CUSTOM_HEADER_ROWS.CUSTOM_HEADER_NAME}","${customerName}"`,
        `"${CUSTOMER_ACTIVITY_CUSTOM_HEADER_ROWS.CUSTOM_HEADER_MAILING_ADDRESS}","${mailingAddress}"`
    ];

    useEffect(() => {
        if (eventState.eventType == AppEvenType.NewCustomerActivityCreated) {
            fetchActivities(customerId);
            dispatch(clearAppEvent());
        }
    }, [eventState.eventType]);


    const fetchActivities = async (customerId) => {
        try {
            let customerActivity = await customerActivityService.getActivites(customerId, pageNumber);
            let custActivities = customerActivity.data;

            if (customerActivity.status == 206) {
                setLoadMoreButton(true);
            }
            else {
                setLoadMoreButton(false);
            }
            if (pageNumber === 1) {
                setCustomerActivities(custActivities);
                setCustomerActivitiesNoFilter(custActivities);
            }
            else {
                setCustomerActivities(prevData => [...prevData, ...custActivities]);
                setCustomerActivitiesNoFilter(prevData => [...prevData, ...custActivities]);
            }
        }
        catch (ex) {
            if (ex.data?.error?.includes(constant.CustomerTaskConstants.CUSTOMER_DELETED)) {
                toast.error(constant.CUSTOMER_NOT_FOUND);
                props.navigateTo('/customer/customerfilter');
                return;
            }
        }
    };

    useEffect(() => {
        fetchActivities(customerId);
    }, [pageNumber]);

    useEffect(() => {
        customerActivityService.getActivityTypes().then(res => {
            setActivityTypes(res);
        })

        customerActivityService.getTransactionTypes().then(res => {
            setTransactionTypes(res);
        })

        customerActivityService.getPoliciesForCustomer(customerId).then(res => {
            setPoliciesForSelect(res);
            if (res.length === 1) {
                // Set the first policy as default if not already set
                setAddActivityRequest(prev => ({
                    ...prev,
                    policyId: prev.policyId || res[0].value
                }));
            }else{
                setAddActivityRequest(prev => ({
                    ...prev,
                    policyId: prev.policyId || ''
                }));
        }
    });

        fetchCustomerOptions();

    }, []);

    const fetchCustomerOptions = async () => {

        // Fetch and configure customer options
        let custOptions: SelectOption[] = [];
        if (customerInfo?.customer?.id) {
            let displayName = customerInfo?.customer?.firstName + (customerInfo?.customer?.lastName ? ' ' + customerInfo?.customer?.lastName : '');
            custOptions = [
                {
                    label: displayName,
                    value: customerInfo?.customer?.id
                }
            ];
        }
        else {
            let cst = await customerDetailService.fetchCustomerById(props.customerId);
            let displayName = cst?.firstName + (cst?.lastName ? ' ' + cst?.lastName : '');
            if (cst) {
                custOptions = [
                    {
                        label: displayName,
                        value: cst.id
                    }
                ];

                dispatch(updateCustomers(cst));
            }
        }

        setCustomerDependentsForSelect(custOptions);
    }

    const [open, setOpen] = useState({});
    const handleToggle = (id) => {
        setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const loadMoreActivities = () => {
        setPagenumber(prevPageNum => prevPageNum + 1); // Increment page
    };

    const handleCancel = async () => {
        const result = await modalContext.showConfirmation(constant.SliderActivityConstant.ARE_YOU_SURE_TO_EXIT);
        if (!result) {
            return;
        }

        setIsEffectiveDateInvalid(false);
        setEffectiveDateValidError(null);

        setIsActivityDescriptionEmpty(false);

        setIsAddActivityPanelVisible(false);
        setAddActivityRequest(defaultAddActivityRequest)
        setIsActivityTypeEmpty(false);
        setIsPolicyIdEmpty(false)
    }

    const handleAddNewActivity = () => {
        const defaultPolicyId = getDefaultPolicyId();
        setAddActivityRequest({ ...defaultAddActivityRequest, custId: customerId, policyId: defaultPolicyId });
        setIsPolicyIdEmpty(false);
        setIsAddActivityPanelVisible(true);
        setSelectedDate(new Date());
        setSelectedTime(new Date());
        setIsFormSaved(false);
    }

    const handleDateChange = date => {
        setSelectedDate(date);
    };

    const handleTimeChange = time => {
        setSelectedTime(time);
    };

    const handleFilterDateChange = date => {
        onFilterFieldChange('activityDate', date)
    };

    const handleFilterTimeChange = time => {
        onFilterFieldChange('activityTime', time)
    };

const handleFilterEffectiveDateChange = date => {
        onFilterFieldChange('policyEffectiveDate', date)
    };

    const onFieldChange = (name: string, value: string | Date) => {
        setAddActivityRequest({
            ...addActivityRequest,
            [name]: value,
        })
        setIsFormSaved(false);
    }

    
     const onFilterFieldChange = (name: string, value: string | Date) => {
        
        setAddActivityRequestFilter((prevFilter) =>{
        let filter = {...prevFilter};
        filter[name] = value;
        return filter;
        });
        
    }

    useEffect(() => {
       setCustomerActivities(customerActivityService.FilterData(addActivityRequestFilter, customerActivitiesNoFilter));
    }, [addActivityRequestFilter])


    const validateForSave = () => {
        const isDescriptionEmpty = !addActivityRequest.description || addActivityRequest.description.length === 0;
        const isDescriptionTooLong = addActivityRequest.description && addActivityRequest.description.length > MAX_DESCRIPTION_LENGTH;
        const isActivityTypeEmpty = addActivityRequest.activityTypeId === null || addActivityRequest.activityTypeId === undefined || addActivityRequest.activityTypeId.trim() === "";
        const isPolicyIdEmpty = addActivityRequest.policyId === null || addActivityRequest.policyId === undefined || addActivityRequest.policyId.trim() === "";
        setIsActivityDescriptionEmpty(isDescriptionEmpty);
        setIsDescriptionTooLong(isDescriptionTooLong);
        setIsActivityTypeEmpty(isActivityTypeEmpty);
        setIsPolicyIdEmpty(isPolicyIdEmpty);
        let isEffectiveDateInValid = false;
        if (!addActivityRequest.activityEffDate) {
            setIsEffectiveDateInvalid(true);
            setEffectiveDateValidError(constant.FIELD_BLANK);
            isEffectiveDateInValid = true;
        }
        else if (addActivityRequest.activityEffDate > new Date()) {
            setIsEffectiveDateInvalid(true);
            setEffectiveDateValidError(constant.SliderActivityConstant.DATE_CAN_NOT_BE_A_FUTURE_DATE);
            isEffectiveDateInValid = true;
        }
        else {
            setIsEffectiveDateInvalid(false);
            setEffectiveDateValidError(null);
        }

        const isInvalid = isDescriptionEmpty || isDescriptionTooLong || isActivityTypeEmpty || isEffectiveDateInValid || (hasPolicyOptions && isPolicyIdEmpty);
        return isInvalid;
    }

    const submitAddActivity = async (addActivityRequest: CustomerActivityAddRequest) => {
        try {
            await customerActivityService.addNewActivity(addActivityRequest);
            setPagenumber(1);
            setIsFormSaved(true);
            fetchActivities(customerId);
            setAddActivityRequest(defaultAddActivityRequest)
        }
        catch (error) {
            if (error.status == 404) {
                toast.error(constant.CUSTOMER_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
                props.navigateTo('/customer/customerfilter');
            }
            else {
                toast.error(error.data, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
            }
        }
    }

    const handleSaveActivity = () => {
        addActivityRequest.custId = customerId;
        addActivityRequest.activityEffDate = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate(),
            selectedTime.getHours(),
            selectedTime.getMinutes()
        );
        addActivityRequest.policyId = addActivityRequest.policyId === '' ? null : addActivityRequest.policyId;
        addActivityRequest.claimId = addActivityRequest.claimId === '' ? null : addActivityRequest.claimId;
        addActivityRequest.tranTypeId = addActivityRequest.tranTypeId === '' ? null : addActivityRequest.tranTypeId;
        if (!validateForSave()) {
            addActivityRequest.claimId = null; /// AS currently, claims are not persisted.
            submitAddActivity(addActivityRequest);
            setIsAddActivityPanelVisible(false);
        }

    }

    useEffect(() => {
        myContext.formSavedStatus = isFormSaved
    }, [isFormSaved])

    var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    var timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

    const AddNewActivityButton = (
        <Button
            key="filter"
            icon="bi bi-plus-circle"
            onClick={handleAddNewActivity}
            disabled={!canUserCreateCustomerActivity}
            tabIndex={1}
            autoFocus
            id="btnAddActivity"
            onKeyDown={(e) => {
                if (e.key == "Tab" && e.shiftKey) {
                    saveControlRef.current.focus();
                    e.preventDefault();
                }
            }}
            ref={addActivityControlRef}
            //   severity="primary"
            label={label.CustomerActivityLabel.ADD_CUSTOMER_ACTIVITY.toUpperCase()}
            className='text-nowrap align-self-center mb-2'
        />
    );

    const ExportActivityButton = (
        <span className="export-activity-btn-margin">
            <ExportToCsv
                data={exportData}
                headers={exportHeaders}
                fileName={fileName}
                customHeaderRows={customHeaderRows}
                disabled={isExportDisabledForUser}
            />
        </span>
    );
    return (
        <>
            <Container fluid className="activity-scroll-panel">
                <Row>
                    <Column lg={12}>
                        <div className="d-flex justify-content-between py-2">
                            <div>{isUserPermitToViewExportButton && ExportActivityButton}</div>
                            <div>{AddNewActivityButton}</div>
                        </div>
                        {isAddActivityPanelVisible && (
                            <div>
                                <Row style={{ padding: '10px' }}>
                                    <Column lg={8} md={8} style={{ boxSizing: "border-box", borderRight: '2px solid grey' }}>
                                        <Row>
                                            <Column lg={12} md={12} className="col-section-header"><span className="new-entry-main-title">NEW ACTIVITY</span></Column>
                                        </Row>
                                        <Row>
                                            <Column lg={5} md={5}>
                                                <Select
                                                    id='activityTypeSelect'
                                                    label={label.CustomerActivityLabel.ACTIVITY_TYPE}
                                                    placeholder={label.PLEASE_SELECT}
                                                    options={activityTypes}
                                                    tabIndex={2}
                                                    controlId="activityTypeSelect"
                                                    defaultSelected={activityTypes.filter(({ value }) =>
                                                        value?.toLowerCase() === addActivityRequest.activityTypeId?.toLowerCase()
                                                    )}
                                                    onChange={(values) => {
                                                        onFieldChange('activityTypeId', values[0] as string)
                                                    }}
                                                    isRequired={true}
                                                    isInvalid={isActivityTypeEmpty}
                                                    invalidWarning={isActivityTypeEmpty ? constant.FIELD_BLANK : ""}
                                                    className='mb-3'
                                                    showAsFloatingLabel={true}
                                                    multiple={false}
                                                />
                                            </Column>
                                            <Column lg={5} md={5}>
                                                <Row >
                                                    <Column lg={4} md={4}>
                                                        <Label text={label.CustomerActivityLabel.ACTIVITY_EFFECTIVE_DATE} htmlFor={'id'} className={'inlineLable  entry-form-inlineLable'} style={{ whiteSpace: 'nowrap' }} />
                                                    </Column>
                                                    <Column lg={5} md={5}>
                                                        <DateTimePicker
                                                            tabIndex={3}
                                                            selected={selectedDate}
                                                            onChange={handleDateChange}
                                                            className="activityDatePicker"
                                                            minTime={new Date(1990, 0, 1)}
                                                            maxDate={new Date()}
                                                            isInvalid={isEffectiveDateInvalid == true}
                                                            invalidWarning={effectiveDateValidError ? effectiveDateValidError : ''}
                                                            invalidLableClass="lable-error"
                                                        />
                                                    </Column>
                                                    <Column lg={3} md={3}>
                                                        <DateTimePicker
                                                            selected={selectedTime}
                                                            onChange={handleTimeChange}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={15}
                                                            dateFormat="h:mm aa"
                                                            timeCaption="Time"
                                                            placeholderText="hh:mm"
                                                            maxDate={new Date()}
                                                            minTime={new Date(1990, 0, 1)}
                                                            maxTime={new Date()}
                                                            className="activityTimePicker"
                                                            isInvalid={isEffectiveDateInvalid == true}
                                                            tabIndex={4}
                                                        />
                                                    </Column>
                                                </Row>
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={5} md={5}>
                                                <Select
                                                    id='transactionTypeSelect'
                                                    label={label.CustomerActivityLabel.TRANSACTION}
                                                    placeholder={label.PLEASE_SELECT}
                                                    options={transactionTypes}
                                                    defaultSelected={transactionTypes.filter(({ value }) =>
                                                        value?.toLowerCase() === addActivityRequest.tranTypeId?.toLowerCase()
                                                    )}
                                                    onChange={(values) => {
                                                        onFieldChange('tranTypeId', values[0] as string)
                                                    }}
                                                    className='mb-3'
                                                    showAsFloatingLabel={true}
                                                    multiple={false}
                                                    tabIndex={5}
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={12} md={12}>
                                                <Label text={'Description'} htmlFor={'description'} isRequired />
                                                <TextField
                                                    id={'description'}
                                                    value={addActivityRequest.description}
                                                    onChange={handleDescriptionChange}
                                                    onPaste={handleDescriptionPaste}
                                                    title={addActivityRequest.description}
                                                    isInvalid={isActivityDescriptionEmpty || isDescriptionTooLong}
                                                    invalidWarning={
                                                        isActivityDescriptionEmpty
                                                            ? constant.FIELD_BLANK
                                                            : isDescriptionTooLong
                                                                ? constant.ACTIVITY_DESCRIPITON_MAX_WARNING
                                                                : ""
                                                    }
                                                    rows={8}
                                                    tabIndex={6}
                                                />
                                            </Column>
                                        </Row>
                                        <Row className="mt-3 mb-2">
                                            <Column lg={6} md={6}>
                                                <div className="text-left">
                                                    <Button
                                                        className='btn btn-outline-tertiary action-btn-base'
                                                        key="filter"
                                                        onClick={() => handleCancel()}
                                                        tabIndex={10}
                                                        id="btnNotesCancel"
                                                        color='primary'
                                                        outlined={true}
                                                    >{label.CANCEL.toLocaleUpperCase()}
                                                    </Button>
                                                </div>
                                            </Column>
                                            <Column lg={6} md={6}>
                                                <div className="text-right">
                                                    <Button
                                                        className='btn action-btn-base'
                                                        key="filter"
                                                        onClick={() => handleSaveActivity()}
                                                        tabIndex={11}
                                                        id="btnNotesAdd"
                                                        color='primary'
                                                        onKeyDown={(e) => {
                                                            if (e.key == "Tab" && !e.shiftKey) {
                                                                addActivityControlRef.current.focus();
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        ref={saveControlRef}
                                                    >{label.SAVE.toLocaleUpperCase()}
                                                    </Button></div>
                                            </Column>
                                        </Row>
                                    </Column>
                                    <Column lg={4} md={4}>
                                        <Row>
                                            <Column lg={12} md={12} className="col-section-header"><span className="new-entry-main-title">CUSTOMER/ POLICY INFORMATION</span></Column>
                                        </Row>
                                        <Row>
                                            <Column lg={10} md={8} >
                                                <Select
                                                    id='externalTemplateSelect'
                                                    label={label.CustomerActivityLabel.CUSTOMER_SELECT}
                                                    options={customerDependentsForSelect ?? []}
                                                    defaultSelected={customerDependentsForSelect?.filter(({ value }) =>
                                                        String(value) === String(addActivityRequest.custId)
                                                    ) ?? []}
                                                    onChange={(values) => {
                                                        onFieldChange('custId', values[0] as string)
                                                    }}
                                                    tabIndex={7}
                                                    placeholder={label.CustomerActivityLabel.PLEASE_SELECT}
                                                    multiple={false}
                                                    showAsFloatingLabel={true}
                                                    className='mb-3'
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={10} md={8}>
                                                <Select
                                                    id='externalTemplateSelect'
                                                    label={label.CustomerActivityLabel.POLICY_SELECT}
                                                    options={policiesForSelect ?? []}
                                                    defaultSelected={policiesForSelect?.filter(({ value }) =>
                                                        String(value) === String(addActivityRequest.policyId)
                                                    ) ?? []}
                                                    tabIndex={8}
                                                    onChange={(values) => {
                                                        onFieldChange('policyId', values[0] as string)
                                                    }}
                                                    placeholder={label.PLEASE_SELECT}
                                                    multiple={false}
                                                    showAsFloatingLabel={true}
                                                    className='mb-3'
                                                    isInvalid={hasPolicyOptions && isPolicyIdEmpty}
                                                    invalidWarning={hasPolicyOptions && isPolicyIdEmpty ? constant.FIELD_BLANK : ""}
                                                    invalidLableClass="lable-error sld-act-input-error"
                                                    isRequired={hasPolicyOptions}
                                                    sortOptions={false}
                                                />
                                            </Column>
                                        </Row>
                                        <Row>
                                            <Column lg={10} md={8}>
                                                <FloatingLabel
                                                    controlId="claimSelect"
                                                    label={label.CustomerActivityLabel.CLAIM_SELECT}>
                                                    <Form.Control
                                                        type="text"
                                                        name="company"
                                                        placeholder={label.CustomerActivityLabel.CLAIM_SELECT}
                                                        value={addActivityRequest.claimId}
                                                        onChange={(event) => onFieldChange('claimId', event.currentTarget.value)}
                                                        tabIndex={9}
                                                        maxLength={30}
                                                        className='texbox-input'
                                                    />
                                                </FloatingLabel>
                                            </Column>
                                        </Row>
                                        {/* </div> */}
                                    </Column>
                                </Row>
                            </div>
                        )}
                    </Column>
                </Row>
                <Row>
                    <Column lg={12} className="p-0">
                        <div className="activityTableWrapper" ref={tableWrapperRef}>
                            <Table className="activityTable">
                                <thead className="tableHeader">
                                <tr>
                                    <th className="policyCol tbl-header">Policy Number</th>
                                    <th className="actionTypeCol tbl-header">Action Type</th>
                                    <th className="dateCol tbl-header">Date</th>
                                    <th className="timeCol tbl-header">Time</th>
                                    <th className="csrCol tbl-header">CS2 User</th>
                                    <th className="deptCol tbl-header">Department</th>
                                    <th className="descCol tbl-header">Description</th>
                                    <th className="effDateCol tbl-header">Effective Date</th>
                                </tr>
                                 <tr>
                                    <th className="policyCol tbl-header">
                                        <FloatingLabel
                                controlId="policyNumberFilter"
                                label={<>
                                    {label.CustomerActivityLabel.POLICY_NUMBER}
                                </>}
                                className="mb-3"
                            >
                                <Form.Control
                                    tabIndex={150}
                                    type="text"
                                    placeholder=" "
                                    name="policyNumberTxtFilter"
                                    value={addActivityRequestFilter.policyNumber}
                                    onChange={(event) => {
                                        onFilterFieldChange('policyNumber', event.currentTarget.value)
                                        }}
                                    disabled={false}
                                    required
                                    maxLength={60}
                                />
                                </FloatingLabel>
                                    </th>
                                    <th className="actionTypeCol tbl-header">
                                        <Select
                                                    id='activityTypeSelectFilter'
                                                    label={label.CustomerActivityLabel.ACTIVITY_TYPE}
                                                    placeholder={label.PLEASE_SELECT}
                                                    options={activityTypes}
                                                    tabIndex={2}
                                                    controlId="activityTypeSelect"
                                                    defaultSelected={activityTypes.filter(({ value }) =>
                                                        value?.toLowerCase() === addActivityRequestFilter.activityTypeId?.toLowerCase()
                                                    )}
                                                    onChange={(values) => {
                                                        let label = activityTypes.find(x => x.value === (values[0] as string))?.label;
                                                        onFilterFieldChange('activityTypeId', values[0] as string)
                                                        onFilterFieldChange('activityType', label)
                                                    }}
                                                    className='mb-3'
                                                    showAsFloatingLabel={true}
                                                    multiple={false}
                                                />
                                    </th>
                                    <th className="dateCol tbl-header">
                                        <DateTimePicker
                                                            tabIndex={3}
                                                            selected={addActivityRequestFilter.activityDate}
                                                            onChange={handleFilterDateChange}
                                                            className="activityDatePicker filter"
                                                            popperClassName="customer-activity-grid-popper"
                                                            popperProps={{ strategy: 'fixed' }}
                                                            minTime={new Date(1990, 0, 1)}
                                                            maxDate={new Date()}
                                                            isInvalid={isEffectiveDateInvalid == true}
                                                            invalidWarning={effectiveDateValidError ? effectiveDateValidError : ''
                                                            }
                                                        />
                                    </th>
                                    <th className="timeCol tbl-header">
                                        <DateTimePicker
                                                            selected={addActivityRequestFilter.activityTime}
                                                            onChange={handleFilterTimeChange}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={15}
                                                            dateFormat="h:mm aa"
                                                            timeCaption="Time"
                                                            placeholderText="hh:mm"
                                                            maxDate={new Date()}
                                                            minTime={new Date(1990, 0, 1)}
                                                            maxTime={new Date()}
                                                            className="activityTimePicker filter"
                                                            popperClassName="customer-activity-grid-popper"
                                                            popperProps={{ strategy: 'fixed' }}
                                                            isInvalid={isEffectiveDateInvalid == true}
                                                            tabIndex={4}
                                                        />
                                    </th>
                                    <th className="csrCol tbl-header">
                                        <FloatingLabel
                                               controlId="csrFilter"
                                            label={<>
                                                {label.CustomerActivityLabel.CSR}
                                            </>}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                tabIndex={150}
                                                type="text"
                                                placeholder=" "
                                                name="csrTxtFilter"
                                                value={addActivityRequestFilter.custId}
                                                onChange={(event) => {
                                                    onFilterFieldChange('custId', event.currentTarget.value)
                                                    onFilterFieldChange('UserName', event.currentTarget.value)
                                                }}
                                                disabled={false}
                                                required
                                                maxLength={60}
                                            />
                                        </FloatingLabel>
                                    </th>
                                    <th className="deptCol tbl-header">
                                        <FloatingLabel
                                            controlId="departmentFilter"
                                            label={<>
                                                Department
                                            </>}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                tabIndex={150}
                                                type="text"
                                                placeholder=" "
                                                name="departmentTxtFilter"
                                                value={addActivityRequestFilter.department}
                                                onChange={(event) => {
                                                    onFilterFieldChange('department', event.currentTarget.value)
                                                }}
                                                disabled={false}
                                                maxLength={60}
                                            />
                                        </FloatingLabel>
                                    </th>
                                    <th className="descCol tbl-header">
                            <FloatingLabel
                                controlId="descriptionFilter"
                                label={<>
                                    {label.CustomerActivityLabel.DESCRIPTION}
                                </>}
                                className="mb-3"
                            >
                                <Form.Control
                                    tabIndex={150}
                                    type="text"
                                    placeholder=" "
                                    name="descriptionTxtFilter"
                                    value={addActivityRequestFilter.description}
                                    onChange={(event) =>
                                        { 
                                            onFilterFieldChange('description', event.currentTarget.value)
                                        }}
                                    disabled={false}
                                    maxLength={60}
                                />
                                </FloatingLabel>

                                    </th>
                                    <th className="effDateCol tbl-header">
                                         <DateTimePicker
                                                            tabIndex={3}
                                                            selected={addActivityRequestFilter.policyEffectiveDate}
                                                            onChange={handleFilterEffectiveDateChange}
                                                            className="activityDatePicker filter"
                                                            popperClassName="customer-activity-grid-popper"
                                                            popperProps={{ strategy: 'fixed' }}
                                                            minTime={new Date(1990, 0, 1)}
                                                            maxDate={new Date(9999, 11, 31)}
                                                            isInvalid={isEffectiveDateInvalid == true}
                                                            invalidWarning={effectiveDateValidError ? effectiveDateValidError : ''}

                                                        />
                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                {/* {customerActivityies.map(({ date, customerActivities }) => (
                        <React.Fragment key={date}> */}
                                {/* <tr>
                            <td colSpan={10}><strong>{date}</strong></td>
                            </tr> */}
                                {customerActivities.map((activity, index) => (
                                    <React.Fragment key={activity.id}>
                                        <tr onClick={() => handleToggle(activity.id)} style={{ cursor: 'pointer' }} className={`activityRow non-collapsible ${index % 2 === 0 ? 'alternate' : ''}`}>
                                            <td>{activity.policyNumber}</td>
                                            <td style={{ color: "#207ab7" }}>
                                                {open[activity.id] ? <FaChevronDown style={{ color: "#207ab7" }} /> : <FaChevronRight style={{ color: "#207ab7" }} />} {activity.activityType}
                                            </td>
                                            <td>{new Date(activity.activityEffDate).toLocaleDateString('en-US', dateOptions)}</td>
                                            <td>{new Date(activity.activityEffDate).toLocaleTimeString('en-US', timeOptions)}</td>
                                            <td>{activity.csr}</td>
                                            <td>{activity.department}</td>
                                            <td className="truncateDesc">{activity.description}</td>
                                            <td>{activity.polEffDate}</td>
                                            
                                        </tr>
                                        <tr>
                                            <td colSpan={8} style={{ padding: 0 }}>
                                                <Collapse in={open[activity.id]}>
                                                    <div id={`collapse-${activity.id}`} style={{ padding: '10px' }}>
                                                        {/* <Row> */}
                                                            {/* <Column lg={7}> */}
                                                        <Row className="row-space">
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>CSR</strong>
                                                                <div>{activity.csr}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Action</strong>
                                                                <div>{activity.activityType}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Customer</strong>
                                                                <div>{activity.customer}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Company</strong>
                                                                <div>{''}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Saved Date/Time</strong>
                                                                <div>{`${new Date(activity.enteredDate).toLocaleDateString('en-US', dateOptions)} 
           ${new Date(activity.enteredDate).toLocaleTimeString('en-US', timeOptions)}`}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Policy Number</strong>
                                                                <div>{activity.policyNumber}</div>
                                                            </Column>
                                                        </Row>
                                                                {/* <br></br> */}
                                                        <Row className="row-space">
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Action Date/Time</strong>
                                                                <div>{`${new Date(activity.activityEffDate).toLocaleDateString('en-US', dateOptions)} 
           ${new Date(activity.activityEffDate).toLocaleTimeString('en-US', timeOptions)}`}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Policy Effective Date</strong>
                                                                <div>{activity.polEffDate}</div>
                                                            </Column>
                                                            <Column lg={2}>
                                                                <strong style={{ color: "#878686" }}>Claim Number</strong>
                                                                <div>{activity.claimNumber}</div>
                                                            </Column>
                                                            <Column lg={3}>
                                                                <strong style={{ color: "#878686" }}>Policy Expiration Date</strong>
                                                                <div>{activity.polExpDate}</div>
                                                            </Column>
                                                        </Row>
                                                                {/* <br></br> */}
                                                            {/* </Column> */}
                                                        {/* </Row> */}
                                                        <Row>
                                                            <Row>
                                                                <Column lg={12} className="wrapDesc">
                                                                    <strong style={{ color: "#878686" }}>Description</strong>
                                                                    <TextField
                                                                        id={`description-readonly-${activity.id}`}
                                                                        value={activity.description}
                                                                        disabled={true}
                                                                        rows={8}
                                                                        className="descScroll"
                                                                    />
                                                                </Column>
                                                            </Row>
                                                        </Row>
                                                    </div>
                                                </Collapse>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                                {/* </React.Fragment>
                                ))} */}
                            </tbody>
                        </Table>
                        </div>
                        {loadMoreButton == true ? (<Button style={{ marginBottom: '1rem' }} onClick={loadMoreActivities}>Load More</Button>) : ""}
                    </Column>
                </Row>
                {/* </Panel> */}
            </Container>
        </>
    )
}

export default CustomerActivity;